<template>
    <div class="data-market">
        <div class="tab-container">
            <div :class="['tab', {active: tab===0}]" 
                @click="onChangeTab(0)">
                作答中心
            </div>
            <div :class="['tab', {active: tab===1}]" 
                @click="onChangeTab(1)">
                作答记录
            </div>
        </div>
        <survey-list v-if="tab === 0" :list="list"></survey-list>
        <record-list v-else :list="list"></record-list>
        <el-pagination
            background
            class="pagination"
            layout="prev, pager, next"
            :page-size="10"
            :current-page="pageIndex"
            :total="total"
            @current-change="onChangePage">
        </el-pagination>
    </div>
</template>

<style scoped>
.data-market{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 1.07rem;
}
.tab-container{
    width: 8.27rem;
    height: 1.39rem;
    background: #fff;
    border: 1px solid var(--theme);
    border-radius: 30px;
    margin: 1.07rem auto 1.28rem auto;
}
.tab{
    width: 3.58rem;
    height: 100%;
    line-height: 1.39rem;
    text-align: center;
    border-radius: 30px;
    display: inline-block;
    cursor: pointer;
}
.tab.active{
    width: 4.53rem;
    background: var(--theme);
    color: #fff;
}
.pagination{
    margin: 30px auto;
}
.pagination /deep/ li{
    margin: 0 1px!important;
}
</style>

<script>
import { DataMarket } from '@/models/data-market'
import SurveyList from '@/components/data-market/m/survey-list.vue'
import RecordList from '@/components/data-market/m/record-list.vue'

export default {
    data(){
        return {
            tab: 0,
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            list: []
        }
    },
    components: {
        SurveyList,
        RecordList
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            this._initList()
        },
        onChangeTab(index){
            if(this.tab === index){
                return
            }
            this.pageIndex = 1
            this.tab = index
            this._initList()
        },
        onChangePage(index){
            this.pageIndex = parseInt(index)
            this._initList()
        },
        _initList(){
            if(this.tab === 0){
                this._getDataMarket(this.pageSize,this.pageIndex)
            }else{
                this._getAnswerRecords(this.pageIndex)
            }
        },
        _getDataMarket(pageSize,pageIndex){
            DataMarket.getDataMarket(pageSize,pageIndex).then(res => {
                this._handleTableList(res)
            })
        },
        _getAnswerRecords(pageIndex){
            DataMarket.getAnswerRecords(pageIndex).then(res => {
                this._handleTableList(res)
            })
        },
        _handleTableList(res){
            if(res.success){
                this.list = res.data
                this.total = res.total
            }else{
                this.list = []
                this.total = 0
                this.$alert(res.message, '提示', {
                    type: 'error'
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/m-content/data-market.vue